import React, { useEffect, useState } from "react";
import { useData } from "../context/DataContext";
import { formatEditAt } from "../utils/editAudit";
import {
  DEFAULT_SOCIAL_LINKS,
  SOCIAL_LINK_FIELDS,
  mergeSocialLinks,
} from "../utils/socialLinks";

const SocialLinks = () => {
  const {
    deleteLoading,
    websiteContentData,
    fetchAndUpdateWebsiteContent,
  } = useData();
  const [links, setLinks] = useState(DEFAULT_SOCIAL_LINKS);

  useEffect(() => {
    if (websiteContentData) {
      setLinks(mergeSocialLinks(websiteContentData.social_links));
    }
  }, [websiteContentData]);

  const handleChange = (key, value) => {
    setLinks((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!websiteContentData) return;

    const cleaned = {};
    for (const field of SOCIAL_LINK_FIELDS) {
      cleaned[field.key] = (links[field.key] || "").trim();
    }

    fetchAndUpdateWebsiteContent(
      {
        ...websiteContentData,
        social_links: cleaned,
      },
      { file: null, extension: "", imageURL: "" }
    );
  };

  if (!websiteContentData) {
    return (
      <div className="container mt-4">
        <p>Loading admin content…</p>
      </div>
    );
  }

  return (
    <div className="container mt-4 mb-5">
      <h2 className="mb-2">Social Links</h2>
      <p className="text-muted mb-3">
        These links appear in the TargeTube app drawer and on the website. Leave
        a field empty to hide that platform icon, then click Update Links.
      </p>
      {(websiteContentData.last_edit_ip ||
        websiteContentData.last_edit_location ||
        websiteContentData.last_edit_by) && (
        <p className="small text-secondary mb-3">
          Last edit:{" "}
          <strong>{websiteContentData.last_edit_ip || "—"}</strong>
          {" · "}
          <strong>{websiteContentData.last_edit_location || "—"}</strong>
          {websiteContentData.last_edit_by
            ? ` · by ${websiteContentData.last_edit_by}`
            : ""}
          {websiteContentData.last_edit_at
            ? ` · ${formatEditAt(websiteContentData.last_edit_at)}`
            : ""}
        </p>
      )}

      <form onSubmit={handleSubmit} className="card p-3 shadow-sm">
        {SOCIAL_LINK_FIELDS.map((field) => (
          <div className="mb-3" key={field.key}>
            <label className="form-label fw-semibold" htmlFor={field.key}>
              {field.label}
            </label>
            <input
              id={field.key}
              type="url"
              className="form-control"
              dir="ltr"
              placeholder={DEFAULT_SOCIAL_LINKS[field.key]}
              value={links[field.key] || ""}
              onChange={(e) => handleChange(field.key, e.target.value)}
            />
          </div>
        ))}

        <button
          type="submit"
          className="btn btn-primary"
          disabled={deleteLoading}
        >
          {deleteLoading ? "Saving…" : "Update Links"}
        </button>
      </form>
    </div>
  );
};

export default SocialLinks;
